import React, { useState } from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import { HelpCircle, ChevronDown } from 'lucide-react';
import '../../../assets/styles/customer/layout/QuickAnswersSection.css';

const QuickAnswersSection = () => {
  const [activeKey, setActiveKey] = useState(null);

  const faqs = [
    {
      id: '0',
      question: 'How do I become a distributor?',
      answer: 'Simply click "Become a Distributor" and fill out the registration form. Our team will verify your details and activate your account within 24 hours.'
    },
    {
      id: '1',
      question: 'Is there a mobile app?',
      answer: 'Our platform is fully mobile-optimized. Native apps for Android and iOS are coming soon!'
    },
    {
      id: '2',
      question: 'How does billing work for customers?',
      answer: 'Customers can view their daily delivery log and monthly summary anytime. Payment can be made via cash or online methods.'
    },
    {
      id: '3',
      question: 'Can I track my delivery routes?',
      answer: 'Yes! Distributors can view optimized routes and track their daily deliveries in real-time through the dashboard.'
    },
    {
      id: '4',
      question: 'What payment methods are supported?',
      answer: 'We support multiple payment methods including cash payments, bank transfers, JazzCash, Easypaisa, and credit/debit cards.'
    }
  ];

  return (
    <section className="quick-answers-section">
      
      {/* Floating Question Marks */}
      <div className="qa-floating-icons">
        <div className="float-qa-icon icon-1">❓</div>
        <div className="float-qa-icon icon-2">💡</div>
        <div className="float-qa-icon icon-3">❔</div>
        <div className="float-qa-icon icon-4">💬</div>
        <div className="float-qa-icon icon-5">📝</div>
      </div>

      {/* Decorative Circles */}
      <div className="qa-circles">
        <div className="qa-circle circle-1"></div>
        <div className="qa-circle circle-2"></div>
        <div className="qa-circle circle-3"></div>
      </div>

      {/* Dot Pattern */}
      <div className="qa-dot-pattern">
        <div className="qa-dot"></div>
        <div className="qa-dot"></div>
        <div className="qa-dot"></div>
        <div className="qa-dot"></div>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="qa-header">
          <div className="qa-icon-badge">
            <HelpCircle size={32} strokeWidth={2} />
          </div>
          <h2 className="qa-title">
            Quick <span className="qa-title-highlight">Answers</span>
          </h2>
          <p className="qa-subtitle">
            Common questions from our users
          </p>
        </div>

        {/* FAQ Accordion */}
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <Accordion 
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
              className="faq-accordion"
            >
              {faqs.map((faq, index) => (
                <Accordion.Item 
                  eventKey={faq.id} 
                  key={faq.id}
                  className="faq-item"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <Accordion.Header className="faq-header">
                    <span className="faq-question">{faq.question}</span>
                    <ChevronDown 
                      size={20} 
                      className={`faq-chevron ${activeKey === faq.id ? 'active' : ''}`}
                    />
                  </Accordion.Header>
                  <Accordion.Body className="faq-body">
                    <p className="faq-answer">{faq.answer}</p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>

      </Container>
    </section>
  );
};

export default QuickAnswersSection;